import React, { FC, MouseEvent, useEffect, useMemo, useState } from 'react';
import { Divider } from '../../../components/divider/divider';
import { Input } from '../../../components/input/input';
import { RadioButton } from '../../../components/radio-button/radio-button';
import { pageKey } from '../../../helpers/path';
import { useQueryParams } from '../../../hooks/use-query-params';
import { IdValue, SortType } from '../../../types/props';
import { sortByName } from '../../table/helpers';
import { AlphabeticSortRadio } from '../../table/table-filter/table-alphabetic-sort/table-alphabetic-sort-radio';
import { DropdownFilterPopup } from '../dropdown-filter-popup/dropdown-filter-popup';
import s from './dropdown-filter-single-select.module.css';

interface Props {
  name: string;
  isOpen: boolean;
  onOpen: (state: boolean) => void;
  options?: IdValue[];
}

export const DropdownFilterSingleSelect: FC<Props> = (props) => {
  const { name, isOpen, onOpen, options = [] } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState<string>();
  const [sortType, setSortType] = useState<SortType>('asc');

  const id = getQueryParams()[name] || '';

  useEffect(() => {
    setChecked(id);
  }, [id]);

  const handleSelect = (item: IdValue) => setChecked(item.id === checked ? undefined : item.id);

  const onSearch = (value: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(value.currentTarget.value);

  const filteredOptions = useMemo(() => {
    return options.filter((item) => item.value.toLowerCase().includes(search.toLowerCase()));
  }, [options, search]);

  const sortedOptions = useMemo(() => {
    return [...filteredOptions].sort((a, b) => sortByName(a.value, b.value, sortType));
  }, [filteredOptions, sortType]);

  const handleOk = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | KeyboardEvent) => {
    addQueryParams({ [name]: checked, [pageKey]: '1' });
    onOpen(false);
    e.stopPropagation();
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setChecked(undefined);
  };

  return (
    <DropdownFilterPopup
      isOpen={isOpen}
      onOpen={onOpen}
      onReset={handleReset}
      onSubmit={handleOk}
      name={name}
    >
      {options.length > 5 && (
        <>
          <Input value={search} onChange={onSearch} placeholder="Поиск" />
          <AlphabeticSortRadio alphabetDirection={sortType} setAlphabetDirection={setSortType} />
          <Divider />
        </>
      )}

      <ul className={s.list}>
        {sortedOptions.map((item) => {
          const isChecked = checked === item.id;
          return (
            <RadioButton
              checked={isChecked}
              onClick={() => handleSelect(item)}
              label={item.value}
              key={item.id}
            />
          );
        })}
      </ul>
    </DropdownFilterPopup>
  );
};
